<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '../../../lib/utils'

/**
 * shadcn-vue `Table`, themed for the console (BG §22: dense but clear). The container scrolls sideways
 * rather than the page (BG §22.3, responsive layout). Surface, rules and type come from the semantic
 * layer in theme.css, so a table sits on a `ZhPanel` or a `Card` without bringing colours of its own.
 */
const props = defineProps<{
    class?: HTMLAttributes['class']
}>()
</script>

<template>
  <div data-slot="table-container" class="relative w-full overflow-x-auto">
    <table data-slot="table" :class="cn('w-full caption-bottom text-sm', props.class)">
      <slot />
    </table>
  </div>
</template>
